import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import store from "./store";
import { authorize_with_code, add_to_slack } from "./api-requests";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: "/app/",
  routes: [
    // {
    //   path: "/",
    //   name: "home",
    //   component: Home,
    //   meta: { requiresAuth: true },
    // },
    {
      path: "/sign-in-to-slack",
      name: "sign-in-to-slack",
      component: Home,
      meta: { requiresAuth: false }
    },
    {
      path: "/add-to-slack",
      name: "add-to-slack",
      component: Home,
      meta: { requiresAuth: false }
    },
    {
      path: "/sign-up",
      name: "sign-up",
      component: () =>
        import(/* webpackChunkName: "sign-up" */ "./views/SignUp.vue"),
      meta: { requiresAuth: true }
    },
    {
      path: "/auth",
      name: "auth",
      component: () =>
        import(/* webpackChunkName: "auth" */ "./views/Auth.vue"),
      meta: { requiresAuth: true }
    },
    {
      path: "/how-to-add",
      name: "how-to-add",
      component: () =>
        import(/* webpackChunkName: "how-to-add" */ "./views/HowToAdd.vue"),
      meta: { requiresAuth: true }
    },
    {
      path: "/floors",
      name: "floors",
      component: () =>
        import(/* webpackChunkName: "floors" */ "./views/Floors.vue"),
      meta: { requiresAuth: true }
    },
    {
      path: "/locations",
      name: "locations",
      component: () =>
        import(/* webpackChunkName: "locations" */ "./views/Locations.vue"),
      meta: { requiresAuth: true }
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue"),
      meta: { requiresAuth: true }
    },
    {
      path: "/terms-of-service",
      name: "terms-of-service",
      component: () =>
        import(/* webpackChunkName: "terms-of-service" */ "./views/TermsOfService.vue"),
      meta: { requiresAuth: true }
    },
    {
      path: "/privacy-policy",
      name: "privacy-policy",
      component: () =>
        import(/* webpackChunkName: "privacy-policy" */ "./views/PrivacyPolicy.vue"),
      meta: { requiresAuth: true }
    },
    {
      path: "/contact",
      name: "contact",
      component: () =>
        import(/* webpackChunkName: "contact" */ "./views/Contact.vue"),
      meta: { requiresAuth: true }
    },
    {
      path: "/sign-in",
      name: "sign-in",
      component: () =>
        import(/* webpackChunkName: "privacy-policy" */ "./views/SigningIn.vue"),
      meta: { requiresAuth: false }
    },
    {
      path: "/added-to-slack",
      name: "added-to-slack",
      component: () =>
        import(/* webpackChunkName: "privacy-policy" */ "./views/AddedToSlack.vue"),
      meta: { requiresAuth: false }
    },
    {
      path: "/logout",
      name: "logout",
      meta: { requiresAuth: true }
    },
    {
      path: "*",
      name: "floors",
      meta: { requiresAuth: true }
    }
  ]
});

function handleSignInRequest(to, from, next) {
  const code = to.query.code;
  console.log("code: ", code);
  const error = to.query.error;
  if (error !== undefined) {
    console.log("error: ", error);
    location.replace(process.env.VUE_APP_HOST_URL);
  }
  authorize_with_code(next, code);
}

function handleAddedToSlack(to, from, next) {
  const code = to.query.code;
  console.log("code: ", code);
  const error = to.query.error;
  if (error !== undefined) {
    console.log("error: ", error);
    location.replace(process.env.VUE_APP_HOST_URL);
  }
  add_to_slack(next, code);
}

router.beforeEach((to, from, next) => {
  console.log("from:", from);
  console.log("to:", to);

  if (
    to.matched.some(record => record.meta.requiresAuth) &&
    localStorage.getItem("logged-in") != "true"
  ) {
    console.log("Not logged in");
    console.log(document.cookie);
    next("sign-in-to-slack");
    return;
  }

  switch (to.name) {
    case "locations": {
      const wantedId = to.query.id;

      if (wantedId !== undefined) {
        for (var b of store.state.buildings) {
          for (var f of b.floors) {
            for (var l of f.locations) {
              if (l.id === wantedId) {
                store.state.selectedBuildingId = b.id;
                store.state.selectedFloorId = f.id;
                store.state.selectedLocationId = l.id;
              }
            }
          }
        }
      }

      // TODO: Scroll to this location on the locationbar.

      // console.log("selectedFloor:", store.state.selectedFloor);
      if (store.state.selectedFloorId === undefined) {
        console.log(
          "Routing to floors instead because there is no floor selected."
        );
        next("/floors");
        return;
      }
      break;
    }

    case "sign-in-to-slack":
      location.replace(
        `https://slack.com/oauth/v2/authorize?user_scope=identity.basic&client_id=${
          process.env.VUE_APP_SLACK_CLIENT_ID
        }&redirect_uri=${process.env.VUE_APP_REDIRECT_URI}`
      );
      return;
    case "add-to-slack":
      location.replace(
        `https://slack.com/oauth/v2/authorize?scope=commands,users:read&client_id=${
          process.env.VUE_APP_SLACK_CLIENT_ID
        }&redirect_uri=${process.env.VUE_APP_REDIRECT_URI}`
      );
      return;
    case "sign-in":
      handleSignInRequest(to, from, next);
      break;
    case "added-to-slack":
      handleAddedToSlack(to, from, next);
      break;

    case "logout":
      console.log("Logging out");
      localStorage.removeItem("logged-in");
      window.location = process.env["VUE_APP_HOST_URL"];
      break;

    default:
      break;
  }

  console.log("Going with the default routing.");
  next();
});

export default router;
